import { dynamicNestedData } from "../js/common.js";

// ********************** Initializations **********************
// --
const navBarControl = document.getElementById("navBarControl");
const navBarToggler = document.getElementById("navBarToggler");
const navBarContent = document.getElementById("navBarContent");
const cartCounter = document.getElementById("cartCounter");
// --
const mainBackDrop = document.getElementById("mainBackDrop");
//--
const cartControl = document.getElementById("cartControl");
// --
const cart_list = document.getElementById("cart_list");

// ********************** Functions **********************
// --
function LoadPage(){
  // --
  var sum = 0;
  
  // --
  const urlParams = new URLSearchParams(window.location.search);
  const itemId = urlParams.get('itemId');

  // -- Initialize Counter
  cart_list.innerHTML = '';

  // Before Database Inclusion (Delete after hooking to database!!!)
  localNestedData = dynamicNestedData;

  // -- Cart Page
  localNestedData.forEach(item => {
    // -- Change to if item is checked!!
    if(item.IsAdded == 1){
      // -- Process Selected item
      // alert(item.IsAdded);

      // -- Process Sum
      sum += item.CartCount;

      // 
      // -- >>>
      const price_Container = document.createElement('div');
      const price_amount_a = document.createElement('p');
      const price_amount_b = document.createElement('p');
      const product_container = document.createElement('div');
      const product_label = document.createElement('p');
      const product_size = document.createElement('p');
      const product_cartControl_container = document.createElement('div');

      const product_cartControl_removal_container = document.createElement('div');
      const product_cartControl_removal = document.createElement('p');
      const product_cartControl_count = document.createElement('p');
      const product_cartControl_addition_container = document.createElement('div');
      const product_cartControl_addition = document.createElement('p');

      const product_cartControl_deletion = document.createElement('p');
      const image_container = document.createElement('div');
      const image_product = document.createElement('img');
      const cart_Container = document.createElement('div');
      const horizontal_rule = document.createElement('hr');
      const listItem = document.createElement('li');

      
      // -- >>>
      price_amount_a.innerHTML = item.Price;
      // price_amount_b.innerHTML = item.Price;
      // price_Container.classList.add('');
      price_Container.appendChild(price_amount_a);

      // --
      product_label.innerHTML = item.Label;
      product_label.classList.add('font_label');
      product_size.innerHTML = item.Size;
      product_size.classList.add('align_center');
      // --
      product_cartControl_removal.innerHTML = '-';
      product_cartControl_removal.classList.add('child_link_ref');

      product_cartControl_removal_container.setAttribute('Id', "cartRemoval");
      product_cartControl_removal_container.classList.add('cartUpdateContainer');
      product_cartControl_removal_container.appendChild(product_cartControl_removal);

      product_cartControl_count.innerHTML = item.CartCount;
      product_cartControl_count.setAttribute('Id', "cartCount");
      product_cartControl_count.classList.add('child_link_ref_label');

      product_cartControl_addition.innerHTML = '+';
      product_cartControl_addition.classList.add('child_link_ref');

      product_cartControl_addition_container.setAttribute('Id', "cartAddition");
      product_cartControl_addition_container.classList.add('cartUpdateContainer');
      product_cartControl_addition_container.appendChild(product_cartControl_addition);
      // --
      product_cartControl_container.classList.add('cart_modify');
      product_cartControl_container.appendChild(product_cartControl_removal_container);
      product_cartControl_container.appendChild(product_cartControl_count);
      product_cartControl_container.appendChild(product_cartControl_addition_container);
      // --
      product_cartControl_deletion.innerHTML = 'Remove';
      product_cartControl_deletion.setAttribute('Id', "cartDeletion");
      product_cartControl_deletion.classList.add('cart_deletion');
      product_container.appendChild(product_label);
      product_container.appendChild(product_size);
      product_container.appendChild(product_cartControl_container);
      product_container.appendChild(product_cartControl_deletion);
      // --
      image_product.src = item.ImgSrc;
      image_product.classList.add('slideshow_cart--resize');
      image_container.appendChild(image_product);
      // --
      cart_Container.classList.add('cart_content_info');
      cart_Container.appendChild(image_container);
      cart_Container.appendChild(product_container);
      cart_Container.appendChild(price_Container);
      // --
      horizontal_rule.classList.add('hr_Cart');
      // --
      listItem.appendChild(cart_Container);
      listItem.appendChild(horizontal_rule);

      // -- Finally
      cart_list.appendChild(listItem);
    }
  });

  // -- Update Counter
  cartCounter.innerHTML = '<sup>' + sum + '</sup>';
}

function ReloadPage(){
  // Before Database Inclusion (Delete after hooking to database!!!)

  // --
  var sum = 0;

  // -- Initialize Counter
  cart_list.innerHTML = '';

  // -- Cart Page
  localNestedData.forEach(item => {
    // -- Change to if item is checked!!
    if(item.IsAdded == 1){
      // -- Process Selected item
      // alert(item.IsAdded);

      // -- Process Sum
      sum += item.CartCount;

      // 
      // -- >>>
      const price_Container = document.createElement('div');
      const price_amount_a = document.createElement('p');
      const price_amount_b = document.createElement('p');
      const product_container = document.createElement('div');
      const product_label = document.createElement('p');
      const product_size = document.createElement('p');
      const product_cartControl_container = document.createElement('div');

      const product_cartControl_removal_container = document.createElement('div');
      const product_cartControl_removal = document.createElement('p');
      const product_cartControl_count = document.createElement('p');
      const product_cartControl_addition_container = document.createElement('div');
      const product_cartControl_addition = document.createElement('p');

      const product_cartControl_deletion = document.createElement('p');
      const image_container = document.createElement('div');
      const image_product = document.createElement('img');
      const cart_Container = document.createElement('div');
      const horizontal_rule = document.createElement('hr');
      const listItem = document.createElement('li');

      
      // -- >>>
      price_amount_a.innerHTML = item.Price;
      // price_amount_b.innerHTML = item.Price;
      // price_Container.classList.add('');
      price_Container.appendChild(price_amount_a);

      // --
      product_label.innerHTML = item.Label;
      product_label.classList.add('font_label');
      product_size.innerHTML = item.Size;
      product_size.classList.add('align_center');
      // --
      product_cartControl_removal.innerHTML = '-';
      product_cartControl_removal.classList.add('child_link_ref');

      product_cartControl_removal_container.setAttribute('Id', "cartRemoval");
      product_cartControl_removal_container.classList.add('cartUpdateContainer');
      product_cartControl_removal_container.appendChild(product_cartControl_removal);

      product_cartControl_count.innerHTML = item.CartCount;
      product_cartControl_count.setAttribute('Id', "cartCount");
      product_cartControl_count.classList.add('child_link_ref_label');

      product_cartControl_addition.innerHTML = '+';
      product_cartControl_addition.classList.add('child_link_ref');

      product_cartControl_addition_container.setAttribute('Id', "cartAddition");
      product_cartControl_addition_container.classList.add('cartUpdateContainer');
      product_cartControl_addition_container.appendChild(product_cartControl_addition);
      // --
      product_cartControl_container.classList.add('cart_modify');
      product_cartControl_container.appendChild(product_cartControl_removal_container);
      product_cartControl_container.appendChild(product_cartControl_count);
      product_cartControl_container.appendChild(product_cartControl_addition_container);
      // --
      product_cartControl_deletion.innerHTML = 'Remove';
      product_cartControl_deletion.setAttribute('Id', "cartDeletion");
      product_cartControl_deletion.classList.add('cart_deletion');
      product_container.appendChild(product_label);
      product_container.appendChild(product_size);
      product_container.appendChild(product_cartControl_container);
      product_container.appendChild(product_cartControl_deletion);
      // --
      image_product.src = item.ImgSrc;
      image_product.classList.add('slideshow_cart--resize');
      image_container.appendChild(image_product);
      // --
      cart_Container.classList.add('cart_content_info');
      cart_Container.appendChild(image_container);
      cart_Container.appendChild(product_container);
      cart_Container.appendChild(price_Container);
      // --
      horizontal_rule.classList.add('hr_Cart');
      // --
      listItem.appendChild(cart_Container);
      listItem.appendChild(horizontal_rule);

      // -- Finally
      cart_list.appendChild(listItem);
    }
  });

  // -- Update Counter
  cartCounter.innerHTML = '<sup>' + sum + '</sup>';
}

function ProcessCartAction(operation, product){
  // --
  localNestedData.forEach(item => {
    // --
    if(item.Label == product){
      console.log(item.Label + " Selected!!");

      // --
      if(operation == "cartRemoval"){
        if(item.CartCount > 1) item.CartCount = item.CartCount - 1;
        else if(item.CartCount = 1){
          item.CartCount = item.CartCount - 1;
          item.IsAdded = 0;
        }
      }
      else if(operation == "cartAddition"){
        item.CartCount = item.CartCount + 1;
      }
      else if(operation == "cartDeletion"){
        item.CartCount = 0;
        item.IsAdded = 0;
      }
    }
  });
  // --
  ReloadPage();
}

// -----------------------------------------------------------------
// -- Initialize Display
LoadPage();
// -----------------------------------------------------------------
var localNestedData;

// ********************** Listeners **********************
// --
cart_list.addEventListener('click', (e) => {
  e.preventDefault();

  if(e.target.classList.contains("cart_deletion")){
    const parentContainerElement = e.target.parentElement.parentElement;
    const label = e.target.parentElement.parentElement.querySelector('p:first-child');
    // --
    ProcessCartAction(e.target.id, label.innerHTML);
  }
  else if(e.target.classList.contains("child_link_ref")){
    const parentContainerElement = e.target.parentElement.parentElement.parentElement.parentElement;
    const productContainerElement = parentContainerElement.querySelector('div:nth-child(2)');
    const label = productContainerElement.querySelector('p:first-child');
    // --
    ProcessCartAction(e.target.parentElement.id, label.innerHTML);
  }
  else if(e.target.classList.contains("cartUpdateContainer")){
    const parentContainerElement = e.target.parentElement.parentElement.parentElement;
    const productContainerElement = parentContainerElement.querySelector('div:nth-child(2)');
    const label = productContainerElement.querySelector('p:first-child');
    // --
    ProcessCartAction(e.target.id, label.innerHTML);
  }
  
});

// -- Single Instance
navBarToggler.addEventListener('click', (e) => {
  e.preventDefault();
  navBarControl.classList.toggle("collapsible--expanded");
  cartControl.classList.toggle("collapsingControl__content");
});

// -- Groups
const gridCollapsibles = document.querySelectorAll(".grid__body--items");
gridCollapsibles.forEach((item) =>
  item.addEventListener("click", function() {
      this.classList.toggle("grid__collapsible");
  })
);
const articleCollapsible = document.querySelectorAll(".article--context");
articleCollapsible.forEach((item) =>
  item.addEventListener("click", function () {
    this.classList.toggle("article__expanded");
  }) 
);